import { getCurrentUser, useAppDispatch, useAppSelector } from 'common';
import { PrivateUserUpdate } from 'common/src/api/models/recipe-header-private-user.models';
import {
  getRecipeHeaderPrivateUsers,
  getRecipePrivateUsers,
  selectAllRecipeHeaderPrivateUsersData,
  selectAllRecipeUsers,
  updateRecipeHeaderPrivateUsers,
} from 'common/src/store/recipes';
import { useEffect } from 'react';
import { getResolution } from '../../../../utilities/resolution';
import UserCheckboxDialog from '../UserCheckboxDialog/UserCheckboxDialog';

export type RecipePrivateUsersDialogProps = {
  customerId: string;
  recipeId: string;
  onClose: () => void;
  onSuccess: () => void;
  setRefreshUser?: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function RecipePrivateUsersDialog(props: RecipePrivateUsersDialogProps): JSX.Element {
  const dispatch = useAppDispatch();

  const user = useAppSelector((s) => s.user.user);
  const privateUsers = useAppSelector((s) => selectAllRecipeHeaderPrivateUsersData(s, props.recipeId));
  const isRecipeHeaderPrivateUsersLoading = useAppSelector((s) => s.recipes.isRecipeHeaderPrivateUsersLoading);
  const recipeUsers = useAppSelector((s) => selectAllRecipeUsers(s.recipes.recipeUsers));
  const isRecipeUsersLoading = useAppSelector((s) => s.recipes.isLoadingRecipeUsers);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);

  useEffect(() => {
    dispatch(getRecipeHeaderPrivateUsers(props.recipeId, props.customerId));
    dispatch(getRecipePrivateUsers(props.customerId, props.recipeId));
  }, [props.recipeId, props.customerId]);

  const handleSubmit = (users: PrivateUserUpdate[]) => {
    const request = {
      UserUpdates: users,
      RecipeHeaderId: props.recipeId,
      ViewAsCustomerId: props.customerId,
    };

    props.onClose();

    dispatch(
      updateRecipeHeaderPrivateUsers(request, getResolution(), () => {
        props.onSuccess();
        if (props.setRefreshUser) {
          props.setRefreshUser(true);
        }
      })
    );
  };

  return (
    <UserCheckboxDialog
      title='Manage secret recipe editors'
      isLoading={isRecipeUsersLoading || isRecipeHeaderPrivateUsersLoading}
      users={recipeUsers}
      defaultCheckedUsers={privateUsers.map((u) => u.UserId)}
      defaultDisabledUsers={user?.UserId ? [user.UserId] : undefined}
      onSubmit={handleSubmit}
      onClose={props.onClose}
    />
  );
}
